/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CallbackRequestBuilderRequestsMetadata, type CallbackRequestBuilder } from './callback/index.js';
// @ts-ignore
import { ConnectRequestBuilderRequestsMetadata, type ConnectRequestBuilder } from './connect/index.js';
// @ts-ignore
import { DisconnectRequestBuilderRequestsMetadata, type DisconnectRequestBuilder } from './disconnect/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/integrations/{integration-id}
 */
export interface IntegrationItemRequestBuilder extends BaseRequestBuilder<IntegrationItemRequestBuilder> {
    /**
     * The callback property
     */
    get callback(): CallbackRequestBuilder;
    /**
     * The connect property
     */
    get connect(): ConnectRequestBuilder;
    /**
     * The disconnect property
     */
    get disconnect(): DisconnectRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const IntegrationItemRequestBuilderUriTemplate = "{+baseurl}/api/integrations/{integration%2Did}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const IntegrationItemRequestBuilderNavigationMetadata: Record<Exclude<keyof IntegrationItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    callback: {
        requestsMetadata: CallbackRequestBuilderRequestsMetadata,
    },
    connect: {
        requestsMetadata: ConnectRequestBuilderRequestsMetadata,
    },
    disconnect: {
        requestsMetadata: DisconnectRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
